import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatErrorOverrideComponent } from '../mat-error/mat-error.component';

@Component({
  selector: 'rma-mat-error-wrapper',
  templateUrl: './mat-error-wrapper.component.html',
  imports: [MatErrorOverrideComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MatErrorWrapperComponent {
  public readonly error = input.required<string>();
}
